import React from 'react';
import { Link } from 'react-router-dom';
import DigLogo from './DigLogo';
import { NAV, CONTACT_INFO } from '../mock';

const Footer = () => {
  return (
    <footer style={{ background: 'var(--navy-deep)', color: 'rgba(255,255,255,0.72)' }}>
      <div className="dig-container py-12">
        <div className="grid gap-10 md:grid-cols-3 items-start">
          <div>
            <DigLogo />
            <p className="font-body mt-5 text-sm max-w-xs" style={{ lineHeight: 1.7 }}>
              A boutique investment firm combining global vision with local knowledge to build,
              grow and create lasting value.
            </p>
          </div>

          <div>
            <h4 className="eyebrow gold-text mb-4">Navigate</h4>
            <ul className="space-y-2">
              {NAV.map((n) => (
                <li key={n.path}>
                  <Link to={n.path} className="font-body text-sm hover:text-[var(--gold)] transition-colors" style={{ color: 'rgba(255,255,255,0.72)' }}>
                    {n.footerLabel || n.label.charAt(0) + n.label.slice(1).toLowerCase()}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="eyebrow gold-text mb-4">Get in touch</h4>
            <p className="font-body text-sm" style={{ lineHeight: 1.9 }}>
              {CONTACT_INFO.office.join(', ')}
            </p>
          </div>
        </div>

        <div
          className="mt-10 pt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3"
          style={{ borderTop: '1px solid rgba(255,255,255,0.1)' }}
        >
          <p className="font-body text-xs" style={{ color: 'rgba(255,255,255,0.55)' }}>
            © {new Date().getFullYear()} Duffy Investment Group. All rights reserved.
          </p>
          <p className="font-body text-xs" style={{ color: 'rgba(255,255,255,0.55)' }}>
            {CONTACT_INFO.abn} &nbsp;|&nbsp; {CONTACT_INFO.acn}
          </p>
          
       
        </div>
      </div>
      <div className="flex items-center justify-between mb-4">
          <span className="text-black"></span>
            <div className="flex gap-4">
                <a href="/sitemap.xml" className="eyebrow gold-text">XML Sitemap</a>
                    <a href="/sitemap.html" className="eyebrow gold-text">HTML Sitemap</a>
                      </div>
                      </div>
    </footer>
  );
};

export default Footer;
